// components/Atoms/Avatar/Avatar.js
import React from 'react';
import PropTypes from 'prop-types';
import { resolveMediaUrl } from '../../../utils/resolveMediaUrl';

const DefaultIcon = () => <span role="img" aria-label="avatar">👤</span>;

const USAGE_PRESETS = {
  nav:     { size: 'sm' },
  comment: { size: 'md' },
  profile: { size: 'lg' },
};

const getInitials = (name) => {
  if (!name) return '';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

const Avatar = ({
  imageUrl  = null,
  userName  = null,
  usage,
  size      = 'md',
  className = '',
  alt,
}) => {
  const finalSize = usage && USAGE_PRESETS[usage] ? USAGE_PRESETS[usage].size : size;

  const sizeClass = {
    xs: 'avatar-xs',
    sm: 'avatar-sm',
    md: 'avatar-md',
    lg: 'avatar-lg',
    xl: 'avatar-xl',
  }[finalSize] || 'avatar-md';

  const [imgFailed, setImgFailed] = React.useState(false);
  const resolvedSrc = resolveMediaUrl(imageUrl);
  const showImage   = resolvedSrc && !imgFailed;
  const computedAlt = alt ?? (userName ? `Avatar de ${userName}` : 'Avatar');

  return (
    <div className={`avatar ${sizeClass} ${className}`} aria-label={computedAlt}>
      {showImage ? (
        <img
          className="avatar-img"
          src={resolvedSrc}
          alt={computedAlt}
          onError={() => setImgFailed(true)}
        />
      ) : userName ? (
        <span className="avatar-initials" aria-hidden="true">
          {getInitials(userName)}
        </span>
      ) : (
        <DefaultIcon />
      )}
    </div>
  );
};

Avatar.propTypes = {
  imageUrl:  PropTypes.string,
  userName:  PropTypes.string,
  usage:     PropTypes.oneOf(['nav', 'comment', 'profile']),
  size:      PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
  alt:       PropTypes.string,
};

export default Avatar;